import { render, staticRenderFns } from "./alignitems.vue?vue&type=template&id=f5f27c6e&lang=pug&"
import script from "./alignitems.vue?vue&type=script&lang=js&"
export * from "./alignitems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f5f27c6e', component.options)
    } else {
      api.reload('f5f27c6e', component.options)
    }
    module.hot.accept("./alignitems.vue?vue&type=template&id=f5f27c6e&lang=pug&", function () {
      api.rerender('f5f27c6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/alignitems.vue"
export default component.exports